import React from 'react';

const Join = () => (
  <section id="join" className="section is-medium has-background-light">
    <div className="container">
      <div className="columns is-centered">
        <div className="column is-8 has-text-centered">
          <h2 className="title is-2 has-text-primary">Join the Network</h2>
          <p className="subtitle is-4 has-text-grey mb-6">
            Ready to be part of Arizona's mesh network revolution?
          </p>
          <p className="content is-size-5 mb-6">
            Connect with fellow mesh network enthusiasts, share knowledge, and help build a more resilient communication infrastructure for Arizona.
          </p>
          <div className="buttons is-centered">
            <a 
              href="https://discord.gg/RPj3b7ZUz9" 
              target="_blank"
              rel="noopener noreferrer"
              className="button is-primary is-large has-text-white"
            >
              <span className="icon">
                <i className="fab fa-discord"></i>
              </span>
              <span>Join our Discord</span>
            </a>
            <a href="/map" className="button is-light is-large">
              <span>Explore the Map</span>
            </a>
          </div>
        </div>
      </div>
    </div>
  </section>
);

export default Join;
